var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner" }, [
    _c(
      "div",
      { staticStyle: { width: "fit-content" } },
      [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  disabled: _vm.readonly,
                  inline: true,
                  "label-position": "left",
                  "label-width": "75px"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.BusinessNo") } },
                  [
                    _c("el-input", {
                      staticClass: "job-no-color",
                      attrs: { disabled: true, no: "jobNo" },
                      model: {
                        value: _vm.job.jobNo,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "jobNo", $$v)
                        },
                        expression: "job.jobNo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SeaExport.CustomerReferenceNumber")
                    }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        no: "customerRefNo",
                        "auto-uppercase": true,
                        trim: true
                      },
                      model: {
                        value: _vm.job.customerRefNo,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "customerRefNo", $$v)
                        },
                        expression: "job.customerRefNo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.poNoRed ? "poNoClass" : "",
                    attrs: { label: _vm.$t("SeaExport.ItemNo") }
                  },
                  [
                    _c("cargo-input", {
                      attrs: { no: "poNo", "auto-uppercase": true },
                      model: {
                        value: _vm.job.poNo,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "poNo", $$v)
                        },
                        expression: "job.poNo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.DateCreated") } },
                  [
                    _c("el-input", {
                      attrs: { no: "today", disabled: true },
                      model: {
                        value: _vm.today,
                        callback: function($$v) {
                          _vm.today = $$v
                        },
                        expression: "today"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c(
              "el-form",
              {
                staticStyle: { display: "flex" },
                attrs: {
                  disabled: _vm.readonly,
                  "label-position": "right",
                  "label-width": "100px"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "section form-column" },
                  [
                    _vm.isZY
                      ? [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.AllowSaleProduct"))
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_AllowSaleProduct,
                                  filterable: "",
                                  no: "allowSaleProduct",
                                  clearable: "",
                                  "data-filter-function": function(p) {
                                    return p.statusEnabled && p.airImportEnabled
                                  },
                                  "default-value": _vm.job.saleProductCode || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.saleProductCode = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.FullOrInside"))
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames
                                      .local_cache_FullOrInside$FULL_OR_INSIDE,
                                  no: "fullOrInside",
                                  clearable: "",
                                  "default-value": _vm.job.fullOrInside || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.fullOrInside = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.SolicitationType") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "solicitationType",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.local_cache_CargoSource,
                            "callback-method-type": "value",
                            "default-value": _vm.job.cargoSource,
                            "callback-params": { key: "cargoSource" },
                            clearable: false
                          },
                          on: { parentCallBack: _vm.cargoSource_Change }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "customJobType",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_CutomJobType,
                            "method-params": {
                              type: _vm.job.lob,
                              active: true
                            },
                            "callback-method-type": "value",
                            "default-value": _vm.job.customJobType,
                            "callback-params": { key: "customJobType" },
                            placeholder: _vm.$t("Message.PleaseSelect")
                          },
                          on: { parentCallBack: _vm.onCustomJobTypeChange }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.job.cargoSource === "NC",
                            expression: "job.cargoSource==='NC'"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.NominatedAgent") }
                          },
                          [
                            _c("cargo-company-select", {
                              attrs: {
                                no: "designationAgentNominated",
                                "method-params": {
                                  overseaAgent: true,
                                  active: true
                                },
                                "default-value": _vm.job.designationAgent || "",
                                "tag-name": "englishName"
                              },
                              on: { change: _vm.designationAgentChangeHandler }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.PortOfLoadingAgent")
                            }
                          },
                          [
                            _c("cargo-company-select", {
                              attrs: {
                                no: "loadingAgentId",
                                "method-params": {
                                  overseaAgent: true,
                                  active: true
                                },
                                "default-value": _vm.job.loadingAgentId || "",
                                "tag-name": "englishName"
                              },
                              on: { change: _vm.loadingAgentChangeHandler }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label:
                            _vm.job.cargoSource === "NC"
                              ? _vm.$t("SeaExport.ActualNotifyParty")
                              : _vm.$t("SeaExport.ConsignationCompany")
                        }
                      },
                      [
                        _c("cargo-sales-company-select", {
                          staticStyle: { width: "180px" },
                          attrs: {
                            no: "customerId",
                            "method-params": { customer: true, active: true },
                            "default-value": _vm.job.customerId || "",
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: {
                            parentCallBack: _vm.txtCustomerId_changeHandler
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ContactPerson") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { no: "customerContact", filterable: "" },
                            model: {
                              value: _vm.job.customerContact,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "customerContact", $$v)
                              },
                              expression: "job.customerContact"
                            }
                          },
                          _vm._l(_vm.contactList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.contactPerson,
                                value: item.contactPerson
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isShowContactPersonDetail,
                            expression: "!isShowContactPersonDetail"
                          }
                        ],
                        attrs: { label: _vm.$t("SeaExport.Tel") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "contactTelephone" },
                          model: {
                            value: _vm.job.contactTelephone,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "contactTelephone", $$v)
                            },
                            expression: "job.contactTelephone"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isShowContactPersonDetail,
                            expression: "!isShowContactPersonDetail"
                          }
                        ],
                        attrs: { label: _vm.$t("SeaExport.Fax") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "contactFax" },
                          model: {
                            value: _vm.job.contactFax,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "contactFax", $$v)
                            },
                            expression: "job.contactFax"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.job.cargoSource !== "NC",
                            expression: "job.cargoSource!=='NC'"
                          }
                        ],
                        attrs: { label: _vm.$t("SeaExport.PortOfLoadingAgent") }
                      },
                      [
                        _c("cargo-company-select", {
                          attrs: {
                            no: "portOfLoadingAgent",
                            "method-params": {
                              overseaAgent: true,
                              active: true
                            },
                            "default-value": _vm.job.loadingAgentId || "",
                            "tag-name": "englishName"
                          },
                          on: { change: _vm.loadingAgentChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.AirlineCompany") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "carrierId",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { airCmp: true, active: true },
                            "callback-params": { key: "carrierId" },
                            "tag-name": "chineseName",
                            "default-value": _vm.job.carrierId || ""
                          },
                          on: { parentCallBack: _vm.txtCarrierId_changeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.FlightNo") } },
                      [
                        _c("cargo-input", {
                          attrs: { no: "voyageFlight", "auto-uppercase": true },
                          model: {
                            value: _vm.job.voyageFlight,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "voyageFlight", $$v)
                            },
                            expression: "job.voyageFlight"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.MasterBillNo") } },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content:
                                _vm.job.express || _vm.mblCodeNumValidate
                                  ? ""
                                  : _vm.$t("queryJob.TheDoesNotComplyRules"),
                              placement: "right-end"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value: _vm.job.express,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "express", $$v)
                                      },
                                      expression: "job.express"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.ExpressInfo"))
                                    )
                                  ]
                                ),
                                _c("cargo-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.job.express,
                                      expression: "job.express"
                                    }
                                  ],
                                  staticStyle: { "margin-left": "2px" },
                                  attrs: {
                                    no: "mblExpress",
                                    maxlength: 32,
                                    "auto-uppercase": true
                                  },
                                  model: {
                                    value: _vm.job.mbl,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "mbl", $$v)
                                    },
                                    expression: "job.mbl"
                                  }
                                }),
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.job.express,
                                      expression: "!job.express"
                                    }
                                  ],
                                  class: _vm.mblCodeNumValidate ? "" : "red",
                                  staticStyle: {
                                    width: "80px",
                                    "margin-left": "2px"
                                  },
                                  attrs: {
                                    value: _vm.mblCode,
                                    no: "mblCode",
                                    maxlength: "3"
                                  },
                                  on: {
                                    input: _vm.onMblCodeInput,
                                    blur: _vm.onMblCodeNumBlur
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.job.express,
                                        expression: "!job.express"
                                      }
                                    ],
                                    staticStyle: {
                                      "padding-right": "2px",
                                      "padding-left": "1.5px"
                                    }
                                  },
                                  [_vm._v("-")]
                                ),
                                _c("cargo-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.job.express,
                                      expression: "!job.express"
                                    }
                                  ],
                                  ref: "mblNum",
                                  class: _vm.mblCodeNumValidate ? "" : "red",
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    no: "mblNum",
                                    maxlength: 8,
                                    "input-convert": _vm.filterNonDigit
                                  },
                                  on: { blur: _vm.onMblCodeNumBlur },
                                  model: {
                                    value: _vm.mblNum,
                                    callback: function($$v) {
                                      _vm.mblNum = $$v
                                    },
                                    expression: "mblNum"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Hbl2") } },
                      [
                        _c("cargo-input", {
                          attrs: { no: "hbl", "auto-uppercase": true },
                          model: {
                            value: _vm.job.hbl,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "hbl", $$v)
                            },
                            expression: "job.hbl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PlaceOfReceipt") } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            no: "dispatchingPlaceAir",
                            "auto-uppercase": true
                          },
                          model: {
                            value: _vm.job.dispatchingPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "dispatchingPlace", $$v)
                            },
                            expression: "job.dispatchingPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.LoadingPort") } },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "loadingPortCodeAir",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Airport,
                            "callback-method-type": "value",
                            "default-value": _vm.job.loadingPortCode,
                            "callback-params": { key: "loadingPortCode" },
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: { parentCallBack: _vm.loadingPortCodeChange }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.PortOfDestination") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "dischargingPortCode",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Airport,
                            "default-value": _vm.job.dischargingPortCode,
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: { parentCallBack: _vm.dischargingPortCode_Change }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.FinalPlaceOfDelivery")
                        }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            no: "destinationPlace",
                            "auto-uppercase": true
                          },
                          model: {
                            value: _vm.job.destinationPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "destinationPlace", $$v)
                            },
                            expression: "job.destinationPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.CustomsDeclarationWay")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "customClaim",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_AirExportConstants$CUSTOM_CLAIMS,
                            "default-value":
                              _vm.job.customClaim === -1
                                ? ""
                                : _vm.job.customClaim,
                            "tag-name": _vm.isZh
                              ? "chineseName"
                              : "englishName",
                            "tag-value": "code",
                            "zero-can-copy": true,
                            fields: [_vm.isZh ? "chineseName" : "englishName"]
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.customClaim = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm.job.customClaim === 1
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.CustomsDeclarationType")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "customsDeclarationType",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames
                                    .basic_data_CustomsDeclarationType,
                                filterable: "",
                                "default-value":
                                  _vm.job.customsDeclarationType === -1
                                    ? ""
                                    : _vm.job.customsDeclarationType,
                                placeholder: _vm.$t(
                                  "CargoMsg.Cargo_keyWordsTip"
                                )
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.job.customsDeclarationType = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Message.TerminalAddress") } },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "deliveryAddress",
                            disabled: _vm.readonly
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("Message.TerminalAddress"),
                                _vm.job.deliveryAddress,
                                undefined,
                                function(val) {
                                  _vm.job.deliveryAddress = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.deliveryAddress,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "deliveryAddress", $$v)
                            },
                            expression: "job.deliveryAddress"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  2
                ),
                _c(
                  "div",
                  {
                    staticClass: "section form-column",
                    style: _vm.$selectByLang("", "width: 350px")
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.DateOfDeparture") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "etd",
                            type: "datetime",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            clearable: ""
                          },
                          model: {
                            value: _vm.job.etd,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "etd", $$v)
                            },
                            expression: "job.etd"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ExpectedArrivalDate")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "eta",
                            type: "datetime",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            clearable: "",
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          model: {
                            value: _vm.job.eta,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "eta", $$v)
                            },
                            expression: "job.eta"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "flex-end"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                no: "copyFromOtherBill"
                              },
                              on: {
                                click: function($event) {
                                  _vm.importPromptTitleDialog.visible = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.CopyFromOtherBill"))
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "codeSearching" },
                              on: {
                                click: function($event) {
                                  _vm.billAddressDialog.visible = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                          )
                        ],
                        1
                      )
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Shipper") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-input", {
                              staticStyle: {
                                width: "70px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                no: "shipperCode",
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                placeholder: _vm.$t("Tool.Code")
                              },
                              model: {
                                value: _vm.job.shipperCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "shipperCode", $$v)
                                },
                                expression: "job.shipperCode"
                              }
                            }),
                            _c("cargo-input", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "shipperLine1",
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("queryJob.DoubleOfLadingHeaderUp")
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.Shipper"),
                                    _vm.mergeShipperLine(),
                                    undefined,
                                    _vm.splitShipperLine
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.shipperLine1,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "shipperLine1", $$v)
                                },
                                expression: "job.shipperLine1"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Consignee") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-input", {
                              staticStyle: {
                                width: "70px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                no: "consigneeCode",
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                placeholder: _vm.$t("Tool.Code")
                              },
                              model: {
                                value: _vm.job.consigneeCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "consigneeCode", $$v)
                                },
                                expression: "job.consigneeCode"
                              }
                            }),
                            _c("cargo-input", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "consigneeLine1",
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("queryJob.DoubleOfLadingHeaderUp")
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.Consignee"),
                                    _vm.mergeConsigneeLine(),
                                    undefined,
                                    _vm.splitConsigneeLine
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.consigneeLine1,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "consigneeLine1", $$v)
                                },
                                expression: "job.consigneeLine1"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.NotifyParty") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-input", {
                              staticStyle: {
                                width: "70px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                no: "notifyCode",
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                placeholder: _vm.$t("Tool.Code")
                              },
                              model: {
                                value: _vm.job.notifyCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "notifyCode", $$v)
                                },
                                expression: "job.notifyCode"
                              }
                            }),
                            _c("cargo-input", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "notifyLine1",
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("queryJob.DoubleOfLadingHeaderUp")
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.NotifyParty"),
                                    _vm.mergeNotifyLine(),
                                    undefined,
                                    _vm.splitNotifyLine
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.notifyLine1,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "notifyLine1", $$v)
                                },
                                expression: "job.notifyLine1"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ActualQuantity") } },
                      [
                        _c("auto-number-input", {
                          attrs: {
                            no: "quantityContract",
                            precision: 0,
                            min: 0
                          },
                          on: { change: _vm.quantityContractCharge },
                          model: {
                            value: _vm.job.quantityActual,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "quantityActual", $$v)
                            },
                            expression: "job.quantityActual"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Package") } },
                      [
                        _c("cargo-packing-select", {
                          attrs: {
                            no: "packing",
                            "default-value": _vm.job.packing
                          },
                          on: {
                            change: function(p) {
                              p.key = "packing"
                              _vm.setJobSelectValue(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ActualWeight") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("auto-number-input", {
                              attrs: {
                                no: "weightContract",
                                precision: 3,
                                min: 0
                              },
                              on: { change: _vm.calculateChargeWeight },
                              model: {
                                value: _vm.job.weightActual,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "weightActual", $$v)
                                },
                                expression: "job.weightActual"
                              }
                            }),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "40px",
                                  "font-size": "12px",
                                  "font-weight": "normal",
                                  color: "#404144"
                                }
                              },
                              [_c("span", [_vm._v("KGS")])]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ActualVolume") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("auto-number-input", {
                              attrs: {
                                no: "cubageContract",
                                precision: 3,
                                min: 0
                              },
                              on: { change: _vm.calculateChargeWeight },
                              model: {
                                value: _vm.job.cubageActual,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cubageActual", $$v)
                                },
                                expression: "job.cubageActual"
                              }
                            }),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "40px",
                                  "font-size": "12px",
                                  "font-weight": "normal",
                                  color: "#404144"
                                }
                              },
                              [_c("span", [_vm._v("CBM")])]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ChargedWeight") } },
                      [
                        _c("auto-number-input", {
                          attrs: { no: "chargeWeight", precision: 3, min: 0 },
                          model: {
                            value: _vm.job.chargeWeight,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "chargeWeight", $$v)
                            },
                            expression: "job.chargeWeight"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_ChineseCargoName")
                        }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            no: "cargoChineseName",
                            type: "textarea",
                            rows: 3,
                            "auto-uppercase": true
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                                _vm.job.cargoChineseName,
                                0,
                                function(val) {
                                  _vm.job.cargoChineseName = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.cargoChineseName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoChineseName", $$v)
                            },
                            expression: "job.cargoChineseName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_EnglishCargoName")
                        }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            no: "cargoEnglishName",
                            type: "textarea",
                            rows: 3,
                            "auto-uppercase": _vm.isUppercaseByConfig
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                                _vm.job.cargoEnglishName,
                                0,
                                function(val) {
                                  _vm.job.cargoEnglishName = val
                                },
                                _vm.isUppercaseByConfig
                              )
                            }
                          },
                          model: {
                            value: _vm.job.cargoEnglishName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoEnglishName", $$v)
                            },
                            expression: "job.cargoEnglishName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.TradeTerms") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "incoTermData",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_IncoTerm,
                            "method-params": {},
                            "callback-method-type": "value",
                            "default-value": _vm.job.incoTerm + "",
                            "callback-params": { key: "incoTerm" }
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            no: "remarks",
                            type: "textarea",
                            rows: 3,
                            "auto-uppercase": true
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                                _vm.job.remarks,
                                0,
                                function(val) {
                                  _vm.job.remarks = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "remarks", $$v)
                            },
                            expression: "job.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "section form-column" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.OperateType") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "operateType",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_ImportConstants$_cargoTypeAirInputList,
                            "callback-method-type": "value",
                            "default-value": _vm.job.operateType,
                            "callback-params": { key: "operateType" },
                            clearable: false
                          },
                          on: { parentCallBack: _vm.onOperateTypeChange }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "cargoType",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_CargoType,
                            "method-params": { air: true },
                            "callback-method-type": "value",
                            "default-value": _vm.job.cargoType,
                            "callback-params": { key: "cargoType" },
                            clearable: false
                          },
                          on: { parentCallBack: _vm.onCargoTypeChagne }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.HBLFreightClause") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "paymentTermHBL",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_PaymentTerm,
                            "callback-method-type": "value",
                            "default-value": _vm.job.paymentTermHBL,
                            "callback-params": { key: "paymentTermHBL" },
                            clearable: false
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.MasterBLFreightTerm")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "paymentTermMBL",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_PaymentTerm,
                            "callback-method-type": "value",
                            "default-value": _vm.job.paymentTermMBL,
                            "callback-params": { key: "paymentTermMBL" },
                            clearable: false
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.TradeTerms2") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "incoTerm",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_IncoTerm,
                            "callback-method-type": "value",
                            "default-value": _vm.job.incoTerm,
                            "callback-params": { key: "incoTerm" },
                            clearable: false
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.TradeMethod") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "tradeTerm",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_TradeTerm,
                            "callback-method-type": "value",
                            "default-value": _vm.job.tradeTerm,
                            "callback-params": { key: "tradeTerm" }
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.AirportHandlingAgent")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "groundAgentId",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": {
                              bookingAgent: true,
                              active: true
                            },
                            "callback-params": { key: "groundAgentId" },
                            "callback-method-type": "value",
                            "default-value": _vm.job.groundAgentId || "",
                            placeholder: " "
                          },
                          on: { parentCallBack: _vm.setJobSelectNum }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "section form-column" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.SalesCompany") } },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: true,
                            no: "txtSalesOffice",
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          model: {
                            value: _vm.txtSalesOffice,
                            callback: function($$v) {
                              _vm.txtSalesOffice = $$v
                            },
                            expression: "txtSalesOffice"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", [
                      _c(
                        "span",
                        {
                          class: _vm.job.cargoSource !== "NC" ? "blue" : "",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-user-select", {
                            ref: "sales",
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "sales",
                              "method-params": {
                                officeId: _vm.salesOfficeCheck
                                  ? _vm.$store.getters.currentOfficeId
                                  : "",
                                category: "role",
                                shape: "sales"
                              },
                              "default-value": _vm.job.sales || "",
                              "static-options": _vm.salesList,
                              placeholder: " "
                            },
                            on: { change: _vm.salesChangeHandler }
                          }),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: {
                                "margin-left": "5px",
                                "margin-right": "0px"
                              },
                              attrs: { no: "provisioned", disabled: true },
                              model: {
                                value: _vm.job.provisioned,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "provisioned", $$v)
                                },
                                expression: "job.provisioned"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Accrued")))]
                          )
                        ],
                        1
                      )
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "cargoSalesId",
                            "method-params": {
                              category: "role",
                              shape: "salesOfGoods"
                            },
                            "default-value": _vm.job.cargoSalesId || "",
                            placeholder: " ",
                            "static-options": _vm.cargoSalesList
                          },
                          on: { change: _vm.cargoSalesChargeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            class: _vm.job.cargoSource === "SC" ? "blue" : "",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.SalesDepartment")))]
                        ),
                        _c("cargo-department-new-select", {
                          attrs: {
                            disabled: !_vm.job.sales,
                            no: "salesOffice",
                            "sales-id": Number(_vm.job.sales),
                            enables: true,
                            "office-id": _vm.job.salesOffice,
                            "department-id": Number(_vm.job.salesDepartment),
                            placeholder: " "
                          },
                          on: { change: _vm.departmentChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.OperationCompany") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "opOffice",
                            disabled: _vm.opOfficeDisabled,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Office,
                            filterable: "",
                            "static-options": _vm.cacheOffices,
                            "callback-params": { key: "opOffice" },
                            "callback-method-type": "value",
                            "default-value": _vm.job.opOffice || "",
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.setJobSelectNum(p)
                              _vm.job.opDepartment = 0
                              _vm.opOfficeChargeHandler()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_OperationDepartment")
                              )
                            )
                          ]
                        ),
                        _c("cargo-department-select", {
                          attrs: {
                            no: "opDepartment",
                            "office-id": Number(_vm.job.opOffice),
                            enables: true,
                            "department-id": Number(_vm.job.opDepartment),
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.job.opDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomerOffice") } },
                      [
                        _c("cargo-office-select", {
                          attrs: {
                            no: "csrOffice",
                            disabled: true,
                            "office-id": Number(_vm.job.csrOffice)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.csrOffice = p.value
                              _vm.job.csrDepartment = 0
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.$t("Message.Customer_Service")))]
                        ),
                        _c("cargo-department-select", {
                          attrs: {
                            no: "csrDepartment",
                            "office-id": Number(_vm.job.csrOffice),
                            enables: true,
                            "department-id": Number(_vm.job.csrDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.csrDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomerService") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "csr",
                            "method-params": { category: "role", shape: "csr" },
                            "default-value": _vm.job.csr || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.csr
                          },
                          on: { change: _vm.csrChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Operation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "operation",
                            "method-params": {
                              category: "role",
                              shape: "op",
                              officeId:
                                _vm.$store.getters.currentOffice.code === "HB"
                                  ? ""
                                  : _vm.$store.getters.currentOfficeId
                            },
                            "default-value": _vm.job.op || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.op
                          },
                          on: { change: _vm.opChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.DocumentOffice") } },
                      [
                        _c("cargo-office-select", {
                          attrs: {
                            no: "dcOffice",
                            disabled: true,
                            "office-id": Number(_vm.job.dcOffice)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.dcOffice = p.value
                              _vm.job.dcDepartment = 0
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Message.Documentation_Department"))
                            )
                          ]
                        ),
                        _c("cargo-department-select", {
                          attrs: {
                            no: "dcDepartment",
                            "office-id": Number(_vm.job.dcOffice),
                            enables: true,
                            "department-id": Number(_vm.job.dcDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.dcDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Documents") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "dc",
                            "method-params": { category: "role", shape: "doc" },
                            "default-value": _vm.job.dc || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.doc
                          },
                          on: { change: _vm.dcChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.AirlineOffice") } },
                      [
                        _c("cargo-office-select", {
                          attrs: {
                            no: "plannerOffice",
                            disabled: true,
                            "office-id": Number(_vm.job.plannerOffice)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.plannerOffice = p.value
                              _vm.job.plannerDepartment = 0
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.AirlineDepartment"))
                            )
                          ]
                        ),
                        _c("cargo-department-select", {
                          attrs: {
                            no: "plannerDepartment",
                            "office-id": Number(_vm.job.plannerOffice),
                            enables: true,
                            "department-id": Number(_vm.job.plannerDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.plannerDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("CargoMsg.Cargo_AirlinePerson") }
                      },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "planner",
                            "method-params": {
                              category: "role",
                              shape: "airline"
                            },
                            "default-value": _vm.job.planner || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.airline
                          },
                          on: { change: _vm.plannerChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PolOperation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "loadingPortOp",
                            "method-params": {
                              category: "role",
                              shape: "aiop"
                            },
                            "default-value": _vm.job.loadingPortOp || "",
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.job.loadingPortOp = p.value || 0
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PodOperation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "destinationPortOp",
                            "method-params": {
                              category: "role",
                              shape: "aiop"
                            },
                            "default-value": _vm.job.destinationPortOp || "",
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.job.destinationPortOp = p.value || 0
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.FieldOperation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "siteOP",
                            "method-params": {
                              category: "role",
                              shape: "siteOp"
                            },
                            "default-value": _vm.job.siteOP || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.siteOp
                          },
                          on: {
                            change: function(p) {
                              _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.OverseaCustomerService")
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "overseaOp",
                          staticClass: "input2",
                          attrs: {
                            no: "overseaOp",
                            placeholder: " ",
                            "default-value": _vm.job.overseaOp || "",
                            "method-params": {
                              category: "role",
                              shape: "overseaOp"
                            },
                            "static-options": _vm.isHC
                              ? null
                              : _vm.userPortRoleData.overseaOp ||
                                _vm.overseaAgentUsersList,
                            "merge-load": true
                          },
                          on: {
                            change: function(p) {
                              _vm.job.overseaOp = p.value
                              _vm.OverseaCustomerUtils.overseaOpChangeHandler(
                                _vm.view,
                                p
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "taxNature",
                              placeholder: _vm.$t("SeaExport.PleaseSelect"),
                              size: "mini"
                            },
                            model: {
                              value: _vm.job.taxNature,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "taxNature", $$v)
                              },
                              expression: "job.taxNature"
                            }
                          },
                          _vm._l(_vm.TAX_NATURES, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _c("import-prompt-title-dialog", {
          attrs: {
            visible: _vm.importPromptTitleDialog.visible,
            lob: _vm.job.lob
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.importPromptTitleDialog, "visible", $event)
            },
            selected: _vm.onExcerptionChangeFunc
          }
        }),
        _c("import-bill-address-title-dialog", {
          attrs: { visible: _vm.billAddressDialog.visible, job: _vm.job },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.billAddressDialog, "visible", $event)
            },
            callback: _vm.codeSearchCallback
          }
        }),
        _c(
          "el-dialog",
          {
            directives: [
              { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
            ],
            attrs: {
              visible: _vm.advanceTextDialog.visible,
              title: _vm.advanceTextDialog.title,
              width: "665px",
              "close-on-click-modal": false,
              "close-on-press-escape": false
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.advanceTextDialog, "visible", $event)
              }
            }
          },
          [
            _c("cargo-rich-textarea", {
              staticStyle: { height: "198px" },
              attrs: {
                no: "textChars",
                disabled: _vm.readonly,
                "text-chars": _vm.advanceTextDialog.textChars,
                "auto-uppercase": _vm.advanceTextDialog.isUppercase,
                "warning-count": -1
              },
              model: {
                value: _vm.advanceTextDialog.value,
                callback: function($$v) {
                  _vm.$set(_vm.advanceTextDialog, "value", $$v)
                },
                expression: "advanceTextDialog.value"
              }
            }),
            _c(
              "span",
              { attrs: { slot: "footer" }, slot: "footer" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isEdit,
                        expression: "isEdit"
                      }
                    ],
                    attrs: { type: "primary" },
                    on: { click: _vm.finishAdvanceText }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "close" },
                    on: {
                      click: function($event) {
                        _vm.advanceTextDialog.visible = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }